import Field from "../../../components/ui/Field";
import { formatDate } from "../../../utils/date";
import EmptyState from "../components/EmptyState";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Profile.module.css";

const PersonalSection = ({ profile, personalDetails: details }) => (
  <>
    <h6 className={styles.sectionTitle}>Email</h6>
    <div className={ui.fieldGrid}>
      <Field label="Company email">{profile.companyEmail}</Field>
      <Field label="Personal email">{profile.personalEmail}</Field>
    </div>

    <h6 className={styles.sectionTitle}>Personal details</h6>
    {details ? (
      <div className={ui.fieldGrid}>
        <Field label="Gender">{details.gender}</Field>
        <Field label="Civil status">{details.civilStatus}</Field>
        <Field label="Birth date">
          {details.birthDate && formatDate(details.birthDate)}
        </Field>
        <Field label="Birth place">{details.birthPlace}</Field>
        <Field label="Religion">{details.religion}</Field>
        <Field label="Height">{details.height}</Field>
        <Field label="Weight">{details.weight}</Field>
        <Field label="Mother's maiden name">{details.mothersMaidenName}</Field>
        <Field label="Contact number">{details.contactNumber}</Field>
        <Field label="Alternate number">{details.alternateContactNumber}</Field>
      </div>
    ) : (
      <EmptyState />
    )}
  </>
);

export default PersonalSection;
